import type {TariffListResponse} from '@yandex-delivery/api/repo/tariffs'
import {raise} from '@yandex-delivery/utils'

export function validateTariffs(tariff?: string) {
  return function _validateTariffs(response: TariffListResponse) {
    if (tariff && !response.tariffs.some(({id}) => tariff === id)) {
      raise(`Wrong tariff: ${tariff}`)
    }

    return response
  }
}
